// Import the functions you need from the SDKs you need
import { initializeApp, getApp, getApps } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBe_YMXh34J-gmXPX2yAityx0wnxkiXODM",
  authDomain: "jooust-pmis.firebaseapp.com",
  projectId: "jooust-pmis",
  storageBucket: "jooust-pmis.firebasestorage.app",
  messagingSenderId: "426682900792",
  appId: "1:426682900792:web:9aef6d53ce373044d121cd",
  measurementId: "G-V3XK8X2GLN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
let analytics = null;

function getSecondaryAuth() {
  const secondaryName = "secondary";
  const secondaryApp = getApps().some((item) => item.name === secondaryName)
    ? getApp(secondaryName)
    : initializeApp(firebaseConfig, secondaryName);
  return getAuth(secondaryApp);
}

if (typeof window !== "undefined") {
  isSupported()
    .then((supported) => {
      if (supported) {
        analytics = getAnalytics(app);
      }
    })
    .catch(() => {
      analytics = null;
    });
}

export { app, auth, db, storage, analytics, getSecondaryAuth };
